<template>
  <modal-layout :is-open="isOpen" class="Modal__accordion" @close="modalClose">
    <div class="Modal_area">
      <div class="Modal_title">
        インストラクターで選ぶ
      </div>
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner modal__container">
        <ul class="Search_instructor_list">
          <li class="Search_instructor_list_box">
            <a
              class="Search_instructor_list_link"
              @click="searchInstructor('multi', 'コラボクラス')"
            >
              <span
                class="Search_instructor_list_img"
                style="background-image: url(assets/img/instructors/multi.png);"
              />
              コラボクラス
            </a>
          </li>
          <li v-for="instructor in listInstructors" :key="instructor.id" class="Search_instructor_list_box">
            <a
              class="Search_instructor_list_link"
              @click="searchInstructor(instructor.id, instructor.name)"
            >
              <span :style="{backgroundImage: 'url(' + convertAvatar(instructor.image_url) +')'}" class="Search_instructor_list_img" />{{ instructor.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'
import instructorService from '@/services/instructorService'
import { convertAvatar } from '@/helpers'

export default {
  name: 'MelonTVScheduleModal2',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listInstructors: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    modalClose() {
      this.$emit('close')
    },
    async init() {
      await this.getListInstructors()
    },
    async getListInstructors() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await instructorService.index()
      this.listInstructors = response.data.filter((ins) => ins.search_flg === 1)
      this.$store.dispatch('loading/updateLoading', false)
    },
    searchInstructor(instructorId, instructorName) {
      this.$emit('searchMelonTv', { searchInstructor: instructorId, name: instructorName })
      this.$emit('close')
    },
    convertAvatar(url) {
      return convertAvatar(url)
    }
  }
}
</script>
